import { booklists } from '@/mocks/comics';

export default function Booklists() {
  return (
    <section id="booklist" className="w-full bg-background-950 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-10 max-w-2xl">
          <span className="mb-3 inline-flex items-center gap-1.5 text-sm font-medium text-accent-400">
            <i className="ri-bookmark-fill" />
            CURATED BOOKLISTS
          </span>
          <h2 className="font-heading text-2xl font-bold text-foreground-50 md:text-4xl">
            追更专题书单
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-400 md:text-base">
            按场景与口味整理的主题书单，每份都有明确的选题和编辑手记，想追哪份收哪份。
          </p>
        </div>

        <div className="flex flex-col gap-6">
          {booklists.map((list, i) => (
            <article
              key={list.id}
              className="group grid grid-cols-1 overflow-hidden rounded-xl border border-background-800 bg-background-900/60 transition-colors hover:border-secondary-500/40 lg:grid-cols-5"
            >
              <div className={`relative w-full overflow-hidden lg:col-span-2 ${i % 2 === 1 ? 'lg:order-2' : ''}`}>
                <img
                  src={list.image}
                  alt={`${list.title} 专题书单配图`}
                  title={`${list.title} - 香蕉漫画社追更书单`}
                  className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                  style={{ minHeight: '220px' }}
                  loading="lazy"
                />
              </div>
              <div className="flex flex-col justify-center gap-4 p-6 md:p-8 lg:col-span-3">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="inline-flex items-center gap-1 rounded-md bg-accent-500/15 px-2.5 py-1 text-xs font-bold text-accent-300">
                    <i className="ri-book-2-fill text-[11px]" />
                    {list.count} 部精选
                  </span>
                  {list.tags.map((tag) => (
                    <span
                      key={tag}
                      className="inline-flex items-center rounded-md bg-secondary-500/15 px-2.5 py-1 text-xs text-secondary-300"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <h3 className="font-heading text-xl font-bold text-foreground-50 md:text-2xl">{list.title}</h3>
                <p className="text-sm font-medium text-primary-300">{list.subtitle}</p>
                <p className="text-sm leading-relaxed text-foreground-400">{list.description}</p>
                <div className="mt-1 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                  <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className="ri-user-star-line text-primary-400" />
                    编辑：{list.editor}
                  </span>
                  <a
                    href="#daily"
                    className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-bold text-foreground-950 transition-colors hover:bg-primary-400 sm:w-auto"
                  >
                    收藏这份书单
                    <i className="ri-arrow-right-line ml-1.5 text-[15px]" />
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}